import {Link, useNavigate} from "react-router-dom";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {Card, Chip} from "@mui/material";
import Meta from "../common/Meta";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Footer from "../Footer";
import Grid from "@mui/material/Grid";
import {getEventTemplates, getMyCompany, saveMyCompanyTemplates,} from "../common/api/WebApi";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import * as pagination from "../common/pagination";
import {getCookie, setCookie} from "../common/appCookie";
import DataTable from "react-data-table-component";
import BootyPagination from "../common/bootyPagination";
import PageLoading from "../common/PageLoading";
import {displayDuration, formatCurrency} from "../common/Utils";
import Icon from "@mui/material/Icon";
import Avatar from "@mui/material/Avatar";
import {
  deleteEventCategory,
  getAgeRangeTypes,
  getInventoryEventTypes,
  saveInventoryEventType
} from "../common/api/InventoryApi";
import SortEventTypes from "../inventory/SortEventTypes";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import Menu from "@mui/material/Menu";
import NotificationItem from "../Items/NotificationItem";
import ManageInventoryEventTypeModal from "../inventory/ManageInventoryEventTypeModal";
import Confirm from "../common/Confirm";
import FileSelector from "../calendarUI/FilterSelector";


export default function EventTemplates(props) {

  const [context, setContext] = useContext(AppContext);
  const navigate = useNavigate();

  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [render, setRender] = useState(0);
  const [startPage, setStartPage] = useState(0);
  const [templates, setTemplates] = useState([]);
  const [sortOrder, setSortOrder] = useState(1);
  const [sortDir, setSortDir] = useState('asc');
  const [PaginationOptions, setPaginationOptions] = useState(pagination._PaginationOptions);
  const [searchCriteria, setSearchCriteria] = useState();
  const [company, setCompany] = useState();

  useEffect(() => {
    getCompanyTemplates();
    loadCompany();
  }, []);
  const loadCompany = () => {
    getMyCompany().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setCompany(result);
      }
    });
  }
  const getCompanyTemplates = async () => {
    getEventTemplates().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setTemplates(result);
        setEventsFiltered(result);
        setLoading(false);
      }
    });
  }

  const handleSort = (column, sortDirection) => {

    setSortOrder(column.id);
    setSortDir(sortDirection);
    setCookie('EVENT_TEMPLATES_SORT', column.id);
    setCookie('EVENT_TEMPLATES_SORT_DIR', sortDirection);

    setRender(render + 1);

  };
  const _columns = [
    {
      name: <span className='th'>Name</span>,
      id: 1,
      selector: row => row.name,
      cell: row => {
        let link = '/event/view/' + row.guid;
        return <Link to={link} className="link"> {row.name} </Link>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Event Type</span>,
      id: 2,
      selector: row => row?.eventType?.name,
      cell: row => {
        return <span>{row?.eventType?.name}</span>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Inventory Type</span>,
      id: 4,
      selector: row => row?.inventoryType?.name,
      cell: row => {
        return <span>{row?.inventoryType?.name}</span>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Age Range</span>,
      id: 5,
      selector: row => row?.ageRange?.name,
      cell: row => {
        return <span>{row?.ageRange?.name}</span>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Length</span>,
      id: 6,
      selector: row => row?.duration,
      cell: row => {
        return <span>{displayDuration(row)}</span>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>View</span>,
      id: 3,
      right: true,
      selector: row => row.guid,
      cell: row => {
        let link = '/sales/create/event?fromTemplate=' + row.guid;
        return <div><MDButton onClick={() => {
          navigate(link)
        }} size="small" color="primary">Create Event</MDButton></div>
      },
      sortable: false,
    },
  ];

  const [columns, setColumns] = useState(_columns);
  const handleSearchChange = (e) => {
    setSearchCriteria(e.target.value);
  }

  const [inventoryEventTypes, setInventoryEventTypes] = useState([]);
  const [eventTypeFilter, setEventTypeFilter] = useState([]);
  const [ageRangeTypes, setAgeRangeTypes] = useState([]);
  const [ageRangeTypeFilter, setAgeRangeTypeFilter] = useState([]);
  const [eventsFiltered, setEventsFiltered] = useState([]);

  const filteredEvent = (item) => {
    if (!searchCriteria || searchCriteria.length === 0) {
      return true;
    }
    let nameCrit = item.name.toLowerCase();
    let match = nameCrit.match(searchCriteria.toLowerCase());
    if (match && match.length > 0) {
      return true;
    }
    return false;
  }

  const showEvent = (_event) => {
    let show = (eventTypeFilter.length === 0 || eventTypeFilter.indexOf(_event?.eventType?.id) > -1);
    show = show && (ageRangeTypeFilter.length === 0 || ageRangeTypeFilter.indexOf(_event?.ageRange?.id) > -1);
    show = show && filteredEvent(_event);
    return show;
  };

  const filteredEvents = (events) => {
    let _events = [];
    for (let j in events) {
      if (showEvent(events[j])) {
        _events.push(events[j]);
      }
    }
    setEventsFiltered(_events);
  }

  useEffect(()=>{
    filteredEvents(templates);
  },[eventTypeFilter, ageRangeTypeFilter, searchCriteria]);

  const loadInventoryEventTypes = () => {
    getInventoryEventTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventoryEventTypes(result);
      }
    });
  }

  const getAgeRangeTypesFn = () => {
    getAgeRangeTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setAgeRangeTypes(result);
      }
    });
  }

  const handlePageChange = (selector, page) => {
    setStartPage(selector);
  };
  const [savingCompany, setSavingCompany] = useState(false);
  const doToast = (msg) => {
    let _context = {...context};
    const toastMessage = msg ? msg : 'Settings successfully saved.';
    _context.toast = {
      message: toastMessage,
      type: 'success'
    }
    setContext({..._context});
  }
  const handleSaveCompanyTemplates = async (company) => {

    setSavingCompany(true);

    let result = await saveMyCompanyTemplates(company);

    setSavingCompany(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      doToast('Templates saved successfully.')
      // setRefreshCompany(true);
      // setOnEdit(false);
    }
  }

  const [sortEventTypes, setSortEventTypes] = useState(false);

  const EventCategoryActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <MDButton {...bindTrigger(popupState)}
                    variant="outlined"
                    color="secondary"
                    size="small"
                    circular
                    iconOnly
          >
            <Icon>more_horiz</Icon>
          </MDButton>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageInventoryEventTypeFn(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>
            <NotificationItem onClick={(e) => {
              popupState.close();
              confirmDeleteInventory(item)
            }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }
  const [inventoryEventType, setInventoryEventType] = useState(null);
  const [manageInventoryEventType, setManageInventoryEventType] = useState(false);
  const [confirmDeleteInventoryType, setConfirmDeleteInventoryType] = useState(false);
  const [confirmation, setConfirmation] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleCloseDeleteInventory = () => {
    setConfirmDelete(false);
  };

  const handleArchiveEventCategory = async (inventory) => {
    let result = await deleteEventCategory(inventory.guid);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setConfirmDelete(false);
      setReset(true);
    }
  }

  const confirmDeleteInventory = (inventory) => {
    let confirmation = {
      title: 'Archive ' + inventory.name + '?',
      message: 'Confirm archive ' + inventory.name + '?',
      entity: inventory
    }
    setConfirmation(confirmation);
    setConfirmDelete(true);
  }
  const closeInventoryEventTypeSortFn = () => {
    setSortEventTypes(false);
  }

  const addInventoryEventTypeFn = () => {
    manageInventoryEventTypeFn();
  }

  const manageInventoryEventTypeFn = (inventory) => {
    let t = null;
    if (inventory) {
      t = {...inventory};
    }
    setInventoryEventType(t);
    setManageInventoryEventType(true);
  }
  const [inventoryType, setInventoryType] = useState(null);
  const [manageInventoryType, setManageInventoryType] = useState(false);

  const addInventoryTypeFn = () => {
    setInventoryType(null);
    setManageInventoryType(true);
  }

  const handleSaveEventTypesSort = async () => {
    setSortEventTypes(false);
    setReset(true);
  }

  const closeInventoryEventTypeFn = () => {
    setInventoryType(null);
    setManageInventoryEventType(false);
  }

  const saveInventoryEventTypeFn = async (inventoryType) => {
    let result = await saveInventoryEventType(inventoryType);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      closeInventoryEventTypeFn();
      setReset(true);
    }
  }

  const [reset, setReset] = useState(true);

  useEffect(() => {
    if (!reset) {
      return;
    }
    setReset(false);
    loadInventoryEventTypes();
    getAgeRangeTypesFn();
  }, [reset]);

  return (
    <DashboardLayout>
      <Meta pageTitle={'Event Templates'}/>
      <ContextSearchNavbar title="Event Templates"/>

      <MDBox py={3}>
        <MDBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={4}>
              <Card mt={2}>
                <MDBox p={2}>
                  <h5 fontWeight="regular">
                    Event Types

                    <MDButton
                      color="secondary"
                      size="small"
                      className={'pull-right'}
                      onClick={(e) => {
                        addInventoryEventTypeFn();
                      }}>
                      <Icon>event</Icon>&nbsp;Add Event Type
                    </MDButton>
                    
                  </h5>

                  <ul className={'list-group'}>
                    {inventoryEventTypes.map((type, index) => {
                      return (
                        <li
                          className={'list-group-item '}
                          key={index}>
                          {type.id && type.name &&
                            <>
                                  <span className="d-block pull-right">
                                    <EventCategoryActions item={type}/>
                                  </span>
                              {type.backgroundColor && <span style={{
                                background: type.backgroundColor,
                                width: '15px',
                                height: '15px',
                                float: 'left',
                                margin: '4px 2px 2px 0'
                              }}>
                                  </span>}
                              <a
                                href={'#'}
                                onClick={(e) => {
                                  e.preventDefault();
                                  manageInventoryEventTypeFn(type);
                                }}>{type.name}
                              </a>
                            </>
                          }
                          <small className={'text-small my-n2 d-block'}>
                            {type.desc}
                          </small>
                          <small className={'text-small my-n2 d-block'}>
                            {type.waiverGk && type.waiverGk > -1 &&
                              <Chip
                                size="small"
                                className={'m-1 mb-n1'}
                                label={'Waiver: ' + type.waiverName}
                                color="default"/>
                            }

                            {type.disableWaitlist &&
                              <Chip
                                size="small"
                                className={'m-1 mb-n1'}
                                label="Waitlist Disabled"
                                color="info"/>
                            }
                            
                            {type.privateAccess &&
                              <Chip
                                size="small"
                                className={'m-1 mb-n1'}
                                label="Private"
                                color="info"/>
                            }

                            {type.requireAttendees &&
                              <Chip
                                size="small"
                                className={'m-1 mb-n1'}
                                label="Attendees Required"
                                color="info"/>
                            }

                            {type.specialEvent &&
                              <Chip
                                size="small"
                                className={'m-1 mb-n1'}
                                label="Party Event"
                                color="success"/>
                            }

                            {type.memberOnly &&
                              <Chip
                                size="small"
                                className={'m-1 mb-n1'}
                                label="Member Only"
                                color="primary"/>
                            }

                            {type.siblingOptionsEnabled &&
                              <Chip
                                size="small"
                                className={'m-1 mb-n1'}
                                label={'Sibling Drop-In ' + formatCurrency(type.siblingDiscount)}
                                color="primary"/>
                            }

                            {type.infantOptionsEnabled &&
                              <Chip
                                size="small"
                                className={'m-1 mb-n1'}
                                label={'Free Infant rate until ' + (type?.infantDiscountAge || 0) + ' months'}
                                color="primary"/>
                            }

                            {type.eventTypeInformational &&
                              <Chip
                                avatar={<Avatar><Icon>info</Icon></Avatar>}
                                size="small"
                                className={'m-1 mb-n1'}
                                label={'Informational'}
                                color="primary"/>
                            }


                            {type.specialRequest &&
                              <Chip
                                avatar={<Avatar><Icon>check</Icon></Avatar>}
                                // deleteIcon={<Icon>check</Icon>}
                                size="small"
                                className={'m-1 mb-n1'}
                                label="Party Requests"
                                color="info"/>
                            }

                            {type.initialDeposit &&
                              <Chip
                                size="small"
                                className={'m-2'}
                                label={type.depositPercent + '%'}
                                color="secondary"/>
                            }
                          </small>

                          {
                            type.eventInventoryGroups && <span className="d-block">

                                {type.eventInventoryGroups?.sort((a, b) => a.id - b.id).map((group, index) => {
                                  return (
                                    <Chip
                                      key={index}
                                      size="small"
                                      className={'m-1 mb-n1'}
                                      index={index}
                                      avatar={<Avatar
                                        src={group?.inventory.imageThumbUrl || group?.inventory.imageUrl}/>}
                                      label={group?.inventory.name}
                                      variant="outlined"
                                      color="secondary"/>
                                  )
                                })
                                }
                              </span>
                          }

                        </li>
                      )
                    })}
                  </ul>
                </MDBox>
              </Card>
            </Grid>
            <Grid item xs={12} lg={8}>
              <MDBox pb={3}>
                <MDBox mb={3}>
                  <Card>
                    <MDBox p={3} lineHeight={1}>
                      <Grid container>
                        <Grid item xs={10}>
                          <Grid container>
                            <Grid item xs={12} sm={4}>
                              <MDInput type="text"
                                       variant="outlined"
                                       value={searchCriteria || ''}
                                       onChange={handleSearchChange}
                                       className="form-control mb-2" id="searchCriteria" aria-describedby="searchCriteria"
                                       label="Search Templates"/>
                            </Grid>
                            <Grid item xs={12} sm={4} style={{
                              marginTop:'-8px'
                            }}>
                              <FileSelector
                                width={'96%'}
                                types={inventoryEventTypes}
                                typeFilter={eventTypeFilter}
                                filterLabel={'Event Types'}
                                setFilter={(filters) => {
                                  setEventTypeFilter(filters)
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}  sm={4} style={{
                              marginTop:'-8px'
                            }}>
                              <FileSelector
                                width={'96%'}
                                types={ageRangeTypes}
                                typeFilter={ageRangeTypeFilter}
                                filterLabel={'Ages'}
                                setFilter={(filters) => {
                                  setAgeRangeTypeFilter(filters)
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <MDButton
                            onClick={() => {
                              navigate('/sales/create/event?template=new');
                            }}
                            color="info"
                            size="small"
                            className="pull-right"
                            variant="contained">New Template</MDButton>
                        </Grid>
                      </Grid>
                    </MDBox>
                    {!loading && <DataTable
                      striped
                      columns={columns}
                      keyField={'guid'}
                      data={eventsFiltered}
                      onSort={handleSort}
                      highlightOnHover
                      pagination
                      paginationPerPage={20}
                      paginationComponent={BootyPagination}
                      paginationTotalRows={totalRecords}
                      onChangePage={handlePageChange}
                      progressPending={loading}
                      defaultSortFieldId={getCookie('EVENT_TEMPLATES_SORT') || 1}
                      defaultSortAsc={getCookie('EVENT_TEMPLATES_SORT_DIR') === 'desc' ? false : true}
                      paginationComponentOptions={PaginationOptions}
                    />}
                  </Card>
                </MDBox>

                {loading && <PageLoading/>}

              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>

      <Footer mt={5}/>

      {confirmDelete && <Confirm confirmation={confirmation}
                                 show={confirmDelete}
                                 saving={saving}
                                 handleConfirm={handleArchiveEventCategory}
                                 handleSave={handleCloseDeleteInventory}
                                 handleClose={handleCloseDeleteInventory}/>}

      {manageInventoryEventType && <ManageInventoryEventTypeModal
        inventoryEventType={inventoryEventType}
        show={manageInventoryEventType}
        saving={savingCompany}
        handleSave={saveInventoryEventTypeFn}
        handleClose={closeInventoryEventTypeFn}/>}

      {sortEventTypes && <SortEventTypes
        eventTypes={inventoryEventTypes}
        show={sortEventTypes}
        saving={savingCompany}
        handleSave={handleSaveEventTypesSort}
        handleClose={closeInventoryEventTypeSortFn}/>}
    </DashboardLayout>
  );
}